import { notificationConstants } from '../_constants/notification.constants';

const getLastViewedKey = () => {
  const userId = localStorage.getItem('userId') || 'anon';
  return `notifications:lastViewedAt:${userId}`;
};

const readInitialLastViewedAt = () => {
  try {
    const raw = localStorage.getItem(getLastViewedKey());
    return raw ? parseInt(raw, 10) : 0;
  } catch {
    return 0;
  }
};

const initialState = {
  items: [],
  lastViewedAt: readInitialLastViewedAt(),
  // Server-tracked unread count (drives the bell badge). Independent
  // of items.length so the badge can update without a full-list refetch.
  // null (not 0) until the first /unread-count poll lands: useUnreadCount
  // falls back to deriving from loaded items via `typeof === 'number'`, and
  // seeding this as 0 made that check always pass, so the fallback was dead
  // code and the badge read 0 until the poll returned.
  unreadCount: null,
  loading: false,
  error: null,
};

export function notifications(state = initialState, action) {
  switch (action.type) {
    case notificationConstants.LOAD_REQUEST:
      return { ...state, loading: true, error: null };
    case notificationConstants.LOAD_SUCCESS:
      return { ...state, loading: false, items: action.items, error: null };
    case notificationConstants.LOAD_FAILURE:
      return { ...state, loading: false, error: action.error };
    case notificationConstants.UNREAD_COUNT_SUCCESS:
      return { ...state, unreadCount: action.count };
    case notificationConstants.MARK_ONE_READ:
      return {
        ...state,
        items: state.items.map(i => (i.id === action.id ? { ...i, isRead: true } : i)),
        // Decrement optimistically; loadUnreadCount() reconciles straight after.
        unreadCount: typeof state.unreadCount === 'number'
          ? Math.max(0, state.unreadCount - 1)
          : state.unreadCount,
      };
    case notificationConstants.MARK_ALL_READ:
      return {
        ...state,
        items: state.items.map(i => ({ ...i, isRead: true })),
        unreadCount: 0,
      };
    case notificationConstants.MARK_VIEWED:
      try {
        localStorage.setItem(getLastViewedKey(), String(action.timestamp));
      } catch { /* ignore quota errors */ }
      return { ...state, lastViewedAt: action.timestamp };
    case notificationConstants.HYDRATE_VIEWED_AT:
      return { ...state, lastViewedAt: action.timestamp };
    default:
      return state;
  }
}
